import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const Diffs = () => {
    const [reviews, setReviews] = useState([]);

    useEffect(() => {
        fetch(process.env.REACT_APP_BACKEND_URL + 'get_diffs', {
            method: "POST",
            headers: {
                "Content-Type": "text/plain",
            },
            body: JSON.stringify({ token: localStorage.getItem("token"), username: localStorage.getItem("user") }),
        })
            .then(response => response.json())
            .then(data => {
                setReviews(data);
            })
            .catch(error => {
                console.error("Error:", error);
            });
    }, []);


    return (
        <>
            <div className="m-10">
                <div className="border-b border-gray-900/10 pb-12 justify-center">
                    <h1 className="text-base font-semibold leading-7 text-gray-900">Reviews</h1>
                </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-5 lg:grid-cols-8">
                {reviews.map(review => (
                    <div key={review.comment_id + review.owner + review.name} 
                    className={`col-span-1 shadow-md hover:shadow-lg m-5 ${review.correct === false ? 'bg-gray-400' : review.security === true ? 'bg-green-400' : review.security === false ? 'bg-red-400' : ''}`}>
                        <Link to={`/diff/${review.comment_id}/${review.original_commit}/${review.fix_commit}`}>
                            <p><b>Comment_id:</b> {review.comment_id}</p>
                        </Link>
                    </div>
                ))}
            </div>
        </>
    );
};

export default Diffs;